export default __webpack_public_path__ + "static/media/logo.424e7697.svg";